module.exports = __webpack_public_path__ + "static/media/4.f3f3e40e.jpg";